import { useContext } from "react";
import { useNavigate } from "@tanstack/react-router";
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useBulkOrderMode } from "../../hooks/useAuthorisation";
// State
import { useSaveOrder } from "../../state/draftOrderSaveState";
import { getDraftDetailPath } from "../../utils/orderPaths";
// MUI
import Button from "@mui/material/Button";

export const AddToNewOrderBtn = ({ selectedRows }) => {
  // Navigate
  const navigate = useNavigate();
  const bulkOrderMode = useBulkOrderMode();
  // Alert Context
  const { setAlertNotification } = useContext(AlertNotificationContext);
  // Create new order
  const {
    mutate: saveOrder,
    isSuccess: saveSuccess,
    data: saveData,
  } = useSaveOrder();

  // Order Object
  const orderObject = {
    no: "",
    poNo: "",
    status: "",
    branch: "",
    requestedShippingDate: "",
    code: "",
    contact: "",
    name: "",
    address: "",
    address2: "",
    city: "",
    county: "",
    postCode: "",
    country: "",
    homeaddress: "",
    email: "",
    mobileNo: "",
    orderTotal: "",
  };

  // Create new order using selected staff
  const handleAddToNewOrder = () => {
    const staff = [];
    selectedRows.map((row, index) => {
      const person = { no: row, staffLineNo: index };
      staff.push(person);
    });
    saveOrder({
      data: {
        filter: {
          noFilter: "",
        },
        order: orderObject,
        staff: staff,
      },
    });
  };

  // Do this on save order success
  const saveSuccessFunc = () => {
    const orderNo = saveData?.data?.data?.data?.data?.order?.no;
    if (!orderNo) return;
    navigate({ to: getDraftDetailPath(orderNo, bulkOrderMode) });
  };

  // Do this on save order error
  const saveErrorFunc = () =>
    setAlertNotification({
      message: `Error: ${saveData.data.status}: ${saveData.data.statusText}`,
      severity: "error",
    });

  // Hook to check the BC API for errors
  useCheckAPI(
    saveSuccess,
    saveData,
    saveData?.data?.status,
    saveSuccessFunc,
    saveErrorFunc,
  );

  return (
    <Button
      variant="outlined"
      color="success"
      onClick={handleAddToNewOrder}
      disabled={!selectedRows.length}
    >
      Add to New Order
    </Button>
  );
};
